<template>
  <div>
    <div class="create-wrap" :style="{height:createVisible?'0px':'110px'}">
      <div v-if="!createVisible">
        <div>
          <el-input
            size="mini"
            v-model="createTaskForm.title"
            placeholder="请设置标题"
            class="create-reward-title"
          ></el-input>
          <el-input size="mini" v-model="createTaskForm.txt" placeholder="添加备注"></el-input>
        </div>
        <div class="create-bot-wrap">
          <!-- <el-popover
            placement="right"
            width="200"
            trigger="click"
            popper-class="add-user-btn"
          >
            <el-select
              size="mini"
              v-model="userVal"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in userLists"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              icon="el-icon-plus"
              type="primary"
              class="mininer us-ad-btn"
              slot="reference"
              size="mini"
            ></el-button>
          </el-popover> -->
          <el-button
            icon="el-icon-date"
            type="primary"
            class="mininer"
            size="mini"
          >
            今天
          </el-button>
          <el-button
            icon="el-icon-date"
            type="primary"
            class="mininer"
            size="mini"
          >
            明天
          </el-button>

          <div class="other-time">
            <el-button
              icon="el-icon-date"
              type="primary"
              class="mininer"
              size="mini"
              @click="chooseTimeRef"
            >
              其它时间
            </el-button>
            <el-date-picker
              v-model="createTaskForm.date"
              type="datetime"
              placeholder="选择日期时间"
              align="right"
              :picker-options="pickerOptions"
              ref="createDateRef"
              class="pick-date"
              size="mini"
            >
            </el-date-picker>
            <el-input-number
              class="task-count"
              v-model="createTaskForm.count"
              :min="1"
              :max="100"
              size="mini"
              label="积分设置"
            ></el-input-number>
          </div>
          <div class="create-btns-wrap">
            <el-button class="mininer" size="mini" @click="cancelCreate">取消</el-button>
            <el-button
              class="mininer"
              @click="createNewTask"
              type="primary"
              size="mini"
            >
              创建
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div style="position: relative">
      <el-button
        v-if="createVisible"
        @click="changeCreateVisible"
        size="mini"
        type="primary"
        class="createReWall"
      >
        创建
      </el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="悬赏栏" name="first">
        <div class="search-list">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="任务标题">
              <!-- <el-select v-model="formInline.region" placeholder="请选择任务难度" size="mini">
                <el-option label="困难" value="shanghai"></el-option>
                <el-option label="普通" value="beijing"></el-option>
                <el-option label="简单" value="beijing"></el-option>
              </el-select> -->
              <el-input size="mini"></el-input>
            </el-form-item>
            <el-form-item label="积分小于">
              <el-input size="mini"></el-input>
            </el-form-item>
            <el-form-item label="积分大于">
              <el-input size="mini"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
              <el-button type="info" @click="onSubmit" size="mini">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- <div class="create-wrap" :style="{height:createVisible?'30px':'110px'}">
          <div v-if="!createVisible">
            <div>
              <el-input size="mini" placeholder="请设置标题" class="create-reward-title"></el-input>
              <el-input size="mini" placeholder="添加备注"></el-input>
            </div>
            <div class="create-bot-wrap">
              <el-popover
                placement="right"
                width="400"
                trigger="click"
                popper-class="add-user-btn"
              >
                <el-select v-model="userVal" filterable placeholder="请选择">
                  <el-option
                    v-for="item in userLists"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-button
                  icon="el-icon-plus"
                  type="primary"
                  class="mininer us-ad-btn"
                  slot="reference"
                  size="mini"
                ></el-button>
              </el-popover>
              <el-button
                icon="el-icon-date"
                type="primary"
                class="mininer"
                size="mini"
              >
                今天
              </el-button>
              <el-button
                icon="el-icon-date"
                type="primary"
                class="mininer"
                size="mini"
              >
                明天
              </el-button>

              <div class="other-time">
                <el-button
                  icon="el-icon-date"
                  type="primary"
                  class="mininer"
                  size="mini"
                  @click="chooseTimeRef"
                >
                  其它时间
                </el-button>
                <el-date-picker
                  v-model="value2"
                  type="datetime"
                  placeholder="选择日期时间"
                  align="right"
                  :picker-options="pickerOptions"
                  ref="createDateRef"
                  class="pick-date"
                  size="mini"
                >
                </el-date-picker>
              </div>
              <div class="create-btns-wrap">
                <el-button class="mininer" size="mini" @click="cancelCreate">取消</el-button>
                <el-button
                  class="mininer"
                  @
                  type="primary"
                  size="mini"
                >
                  创建
                </el-button>
              </div>
            </div>
          </div>
          <el-button
            v-if="createVisible"
            @click="changeCreateVisible"
            size="mini"
            type="primary"
          >
            创建悬赏
          </el-button>
        </div> -->
        <div id="RewardHall">
          <div
            class="item"
            v-for="(item,index) in reWallList"
            :key="index"
            ref="itemListsRef"
          >
            <div class="title word-nowrap-text">{{ item.title }}</div>
            <div class="content">
              {{ item.txt }}
            </div>
            <div class="fb-user">
              发布人:{{ item.user }}
            </div>
            <div class="bot">
              <div class="count">
                积分:{{ item.count }}
              </div>
              <div class="lingqu" @click="lingquGet(item,index)">
                领取任务
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="我创建的" name="second">
        <el-table
          :data="myCreateReWallLists"
          style="width: 100%"
        >
          <el-table-column
            prop="title"
            label="标题"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="txt"
            label="内容"
            width="180"
          >
            <template v-slot="slotProp">
              <span class="contxt">{{ slotProp.row.txt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="领取时间"
          >
          </el-table-column>
          <el-table-column
            prop="user"
            label="领取人"
          >
          </el-table-column>
          <el-table-column
            prop="edit"
            label="操作"
          >
            <el-button size="mini" type="primary">详情</el-button>
            <el-button size="mini" type="primary">编辑</el-button>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="我领取的" name="third">
        <el-table
          :data="myGetReWallLists"
          style="width: 100%"
        >
          <el-table-column
            prop="title"
            label="标题"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="txt"
            label="内容"
            width="180"
          >
            <template v-slot="slotProp">
              <span class="contxt">{{ slotProp.row.txt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="date"
            label="创建时间"
          >
          </el-table-column>
          <el-table-column
            prop="count"
            label="积分"
          >
          </el-table-column>
          <el-table-column
            prop="user"
            label="创建人"
          >
          </el-table-column>
          <el-table-column
            prop="edit"
            label="操作"
          >
            <el-button size="mini" type="primary">详情</el-button>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch, getCurrentInstance, nextTick } from '@vue/composition-api'
import { a } from './revardWall'
export default {
  name: 'RewardHall',
  props: [

  ],
  setup (props, ctx) {
    let itemListsRef = ref(null)
    let vm = getCurrentInstance()
    function setItemRef (e) {
      itemListsRef.value.push(e)
      console.log(itemListsRef)
    }
    onMounted(() => {
      console.log(vm)
      resertStyle()
    })

    function resertStyle () {
      console.log(2)
      var wrap = document.getElementsByClassName('item')
      let color = ['rgba(255,223,255,.2)', 'rgba(206,236,255,.2)', 'rgba(255,227,185,.2)']
      itemListsRef.value.forEach((v, i) => {
        let c = Math.floor(v.offsetHeight / 10)
        let bcIndec = Math.floor(Math.random() * 3)
        // wrap[i].style.gridRow = `auto / span ${v.clientHeight / 10 + 1}`
        wrap[i].style.gridRowStart = 'auto'
        wrap[i].style.gridRowEnd = 'span ' + c
        wrap[i].style.backgroundColor = color[bcIndec]
        console.log(v)
      })
    }

    function getStringL () {
      let str = '策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点策划活动文案/有一个包裹在下午3点'
      return str.slice(0, Math.random() * 100)
    }
    window.addEventListener('resize', function () {
      resertStyle()
      console.log(2)
    })

    let formInline = reactive({})
    let onSubmit = function () {}

    /// /
    let createVisible = ref(true)
    let changeCreateVisible = function () {
      createVisible.value = false
    }
    let cancelCreate = function () {
      createVisible.value = true
    }
    let createDateRef = ref()
    onMounted(() => {

    })
    let chooseTimeRef = function () {
      createDateRef.value.focus()
    }
    let pickerOptions = ref([])
    let value2 = ref()
    /// /用户名
    let userLists = [{
      value: '1',
      label: '欧洋'
    }, {
      value: '2',
      label: '谢凤'
    }, {
      value: '3',
      label: '谢永超'
    }, {
      value: '4',
      label: '典斌'
    }, {
      value: '5',
      label: '刘诚'
    }]
    let userVal = ref()
    /// /tab----
    let activeName = ref('first')
    let handleClick = function () {}
    // 悬赏列表
    let reWallList = reactive(a)
    // 我创建的悬赏列表
    let myCreateReWallLists = reactive([])
    // 我领取的悬赏列表
    let myGetReWallLists = reactive([])
    // 领取
    let lingquGet = function (v, index) {
      myGetReWallLists.push(v)
      reWallList.splice(index, 1)
      nextTick(() => {
        resertStyle()
      })
    }
    /// ////////
    let createTaskForm = reactive({
      title: '',
      txt: '',
      date: new Date().toLocaleDateString(),
      count: 0,
      user: '李四'
    })

    let createNewTask = function () {
      reWallList.push({ ...createTaskForm })
      myCreateReWallLists.push({ ...createTaskForm })
      createTaskForm.user = '李四'
      createTaskForm.title = ''
      createTaskForm.count = 0
      createTaskForm.txt = ''
      vm.setupContext.root.$message.success('创建成功!')
      cancelCreate()
    }
    return {
      createNewTask,
      createTaskForm,
      myCreateReWallLists,
      myGetReWallLists,
      lingquGet,
      reWallList,
      userVal,
      userLists,
      value2,
      pickerOptions,
      formInline,
      setItemRef,
      itemListsRef,
      getStringL,
      onSubmit,
      createVisible,
      changeCreateVisible,
      cancelCreate,
      createDateRef,
      chooseTimeRef,
      handleClick,
      activeName
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
#RewardHall
  display grid
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  align-items: start
  grid-gap: 10px;
  grid-auto-flow: row dense;  // 是否自动补齐空白
  .item
    overflow: hidden
    border-radius: 10px
    border: 1px solid #ccc
    padding 10px
    &.pink
      background-color: rgba(255,223,255,.2)
    &.blue
      background-color: rgba(206,236,255,.2)
    &.ye
      background-color: rgba(255,227,185,.2)
    .title
      font-size: 18px
      font-weight: bold
      margin-bottom:10px
    .content
      font-size: 14px
      color: rgba(133,133,133,1)
      margin-bottom: 10px
      overflow: hidden
      display: -webkit-box;
      -webkit-line-clamp: 8;
      line-clamp: 8;
      -webkit-box-orient: vertical;
      line-height: 20px
    .fb-user
      font-size: 16px
      margin-bottom: 10px
    .bot
      display: flex
      font-size: 16px
      line-height: 15px
      .count
        color: red
      .lingqu
        margin-left: auto
        color: rgba(64,158,255,1)
        cursor pointer
        &:hover
          color: rgba(0,106,215,1)

.word-nowrap-text
  white-space nowrap
  overflow: hidden
  text-overflow: ellipsis

.create-wrap
  transition: all .6s
  text-align: right
  overflow: hidden
  .create-bot-wrap
    margin-top: 10px
    display flex
    position: relative
    .create-btns-wrap
      margin-left: auto
  .create-reward-title
    margin-bottom: 10px
  .mininer
    padding 4px 8px
  .other-time
    position: relative
    > button
        height: 100%
        vertical-align: top
        margin-left: 10px
        position relative
        z-index: 5
    .pick-date
      position: absolute
      left: 0
      top: 0
      opacity: 0
      width: 86px

.create-bot-wrap
  >>> .us-ad-btn
        height 100%
        vertical-align: top
        margin-right: 10px

.task-count
  margin-left 10px

.contxt
  font-size: 14px
  color: rgba(133,133,133,1)
  margin-bottom: 10px
  overflow: hidden
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  line-height: 20px

.createReWall
  position: absolute
  right 20px
  top 5px
  z-index 99
</style>
